import { Component, Input, OnInit } from '@angular/core';
import { FunctionalCapabilitiesTableSection } from 'src/app/model/shared/functional-capabilities-table-section';

import { documentToHtmlString } from '.';

@Component({
  selector: 'app-functional-capabilities-table-section',
  templateUrl: './functional-capabilities-table-section.component.html',
  styleUrls: ['./functional-capabilities-table-section.component.scss']
})
export class FunctionalCapabilitiesTableSectionComponent implements OnInit {
  @Input() tableSections: FunctionalCapabilitiesTableSection[] = [];
  @Input() ocnTable: boolean = false;
  constructor() {}

  ngOnInit(): void {}

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }
}
